import React, { useState } from 'react';
import { CHECKOUT } from '../data/links';
import { record } from './Gate';
import { SectionHeading } from './SectionHeading';
import { LockChip } from './LockChip';
interface CommunityCardProps {
  memberEmail: string;
}
export function CommunityCard({
  memberEmail
}: CommunityCardProps) {
  const [joined, setJoined] = useState(false);
  const join = () => {
    record(memberEmail, 'community-waitlist');
    setJoined(true);
  };
  return <section aria-label="The Inventor's Club" id="community" className="scroll-mt-24" data-id="element-116" data-mp="3m89mgs8l96lf">
      <SectionHeading index="06" title="The Inventor's Club" locked note="A new build brief every month, with a place to post what your child actually made, collapses included." data-id="element-117" data-mp="3r2du7dpohink">
        <LockChip label="Not open yet" data-id="element-118" data-mp="3h8x0e9pjk3jw" />
      </SectionHeading>

      <article className="mt-10 rounded-[18px] border border-navy/10 bg-white p-6 sm:p-9" data-id="element-119" data-mp="33ct9oqdvmdc6">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-120" data-mp="3899y7lozmtps">
          <div data-id="element-121" data-mp="t7ec75oa3j6c">
            <h3 className="font-display text-[24px] font-semibold leading-tight text-navy/60 sm:text-[30px]" data-id="element-122" data-mp="t6w4ncw61ij4">
              Opening soon
            </h3>
            <p className="mt-3 max-w-[42rem] font-sans text-[15.5px] leading-relaxed text-navy/55" data-id="element-123" data-mp="128vr4kpy9etg">
              One brief a month, written the way the books are: a real constraint, a way to measure
              whether it worked, and the failures to expect. We will email you when it opens.
            </p>
          </div>

          <div className="shrink-0 lg:w-[19rem] lg:border-l lg:border-navy/10 lg:pl-10" data-id="element-124" data-mp="5jwdeq6ljktv">
            {joined ? <div role="status" data-id="element-125" data-mp="jbuhunpd4sjp">
                <p className="font-sans text-[15.5px] leading-relaxed text-navy" data-id="element-126" data-mp="jc45i4mxqnm8">
                  You are on the list.
                </p>
                <p className="mt-1 font-sans text-[13px] leading-relaxed text-navy/55" data-id="element-127" data-mp="3myba4tixfz8j">
                  We will write to {memberEmail || 'your member address'} before places are offered.
                </p>
              </div> : <>
                {CHECKOUT.community ? <a href={CHECKOUT.community} onClick={() => record(memberEmail, 'community-click')} className="block w-full rounded-[12px] border border-navy/20 px-5 py-3 text-center font-sans text-[13px] font-medium text-navy/70 transition-colors duration-150 ease-out hover:border-navy/50 hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-128" data-mp="1qv6mzq2uo54b">
                    Take a place
                  </a> : <button type="button" onClick={join} className="w-full rounded-[12px] border border-navy/20 px-5 py-3 font-sans text-[13px] font-medium text-navy/70 transition-colors duration-150 ease-out hover:border-navy/50 hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-129" data-mp="1gz3meonncejh">
                    Join the waitlist
                  </button>}
                <p className="mt-3 font-sans text-[13px] leading-relaxed text-navy/50" data-id="element-130" data-mp="7vfroqodhm6v">
                  Uses the email you signed in with. Nothing else.
                </p>
              </>}
          </div>
        </div>
      </article>
    </section>;
}